import {
  AutopilotTaskDto,
  TaskCategoryStage,
} from '@urbanx/agx.activities.client'
import {
  AgxBadge,
  AgxIconTask,
  AgxSpacer,
  AgxTypography,
} from '@urbanx/agx.ui-components2'
import { mapTaskTypeToIconType } from 'components/tasks/taskCollapsibleShared'
import { splitPascalCase } from 'utils/stringUtils'

interface TaskCellProps {
  task: AutopilotTaskDto
  index: number
  isNew?: boolean
}

export const TaskCell = ({ task, index, isNew }: TaskCellProps) => {
  return (
    <AgxSpacer direction="horizontal" contentAlignment="center" gap="2xs">
      <div style={{ position: 'relative', display: 'inline-block' }}>
        {isNew && (
          <div
            style={{
              position: 'absolute',
              top: '-8px',
              left: '-24px',
              zIndex: 1,
            }}
          >
            <AgxBadge text="New!" type="colourfill" colour="green" size="sm" />
          </div>
        )}
        <AgxIconTask
          type={mapTaskTypeToIconType(task.category?.taskType)}
          iconColor="black"
          height={32}
          width={32}
          bgColor="var(--bg-progress)"
        />
      </div>
      <AgxTypography
        id={`row-${index}-type`}
        color={isNew ? 'var(--text-primary)' : 'var(--text-secondary)'}
        size="small"
        type={isNew ? 'body_ui_strong' : 'body_ui'}
      >
        {task.category?.stage === TaskCategoryStage.AgreementCompliance
          ? splitPascalCase(TaskCategoryStage.AgreementCompliance)
          : splitPascalCase(task.category?.taskType ?? '')}
      </AgxTypography>
    </AgxSpacer>
  )
}
